import Enllac from 'components/3catinfo/Enllac';
import clsx from 'clsx';
import styles from './botonsidiomes.module.scss';

export default function BotonsIdiomes(props) {
    const { idiomes = null } = props;

    if (!idiomes) return <></>;
    return (
        <div className={styles.botonsIdiomesWrapper}>
            {idiomes.map((idioma) => (
                <Enllac
                    key={`botoIdioma-${idioma.id}`}
                    dataTestId={`botoIdioma-${idioma.id}`}
                    href={idioma.url}
                    className={clsx(styles.botoIdiomes, { [styles.botoActive]: idioma.active })}
                >
                    {idioma.nom}
                </Enllac>
            ))}
        </div>
    );
}
